<template>
  <div>
    <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button>
    </el-radio-group> -->
    <el-menu
      class="leftmenu"
      :collapse="isCollapse"
      router
    >
    <!-- <template v-for="(menu, menuIndex) in childrenMenus.children">
      <el-menu-item :index="menu.path" :route="goRoute(menu)">
        <span sloat="title" class="tip"><i class="el-icon-document-checked"></i><span>{{menu.title}}</span></span>
      </el-menu-item>
    </template>
    <template v-for="(item, subIdex) in reportsMenus" >
      <el-submenu :index="item.reportid+item.reportname">
        <template slot="title">
          <i :class="subclsIcon"></i>
          <span slot="title">{{item.reportname}}</span>
        </template>
        <template  v-for="(report, reportIndex) in item.children">
          <el-menu-item :index="report.reportid+report.reportname" :route="goReportRoute(report)">
            <span sloat="title"><i class="el-icon-s-data"></i>{{report.reportname}}</span>
          </el-menu-item>
        </template>
      </el-submenu>
    </template> -->
    <template v-for="menu in childrenMenus.children">
       <el-menu-item :index="menu.path" :key="menu.path" :route="goRoute(menu)">
        <i :class="menu.menuicon ? menu.menuicon :'el-icon-menu'"></i>
        <span slot="title">{{menu.title}}</span>
      </el-menu-item>
    </template>
  </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  name: "left",
  data() {
    return {
      // isCollapse: false,
      subclsIcon: "el-icon-folder",
    };
  },
  computed: {
    ...mapGetters(["childrenMenus", "tabRoutes", "reportsMenus", 'isCollapse']),
  },
  watch: {},
  methods: {
    closesubreport() {
      this.subclsIcon = "el-icon-folder";
    },
    opensubreport() {
      this.subclsIcon = "el-icon-folder-opened";
    },
    goRoute(menu) {
      // console.log(menu)
      let model = {
        path: menu.path,
        query: { menuid: menu.menuid, doctid: menu.doctid },
      };
      return model;
    },
    goReportRoute(report) {
      let model = {
        path: "/bbzx/reportQuery",
        meta: {
          keepAlive: true,
          title: report.reportname,
        },
        query: { reportid: report.reportid, title: report.reportname },
        params: {},
      };
      return model;
    },
    handleSelect(key, keyPath) {
      //console.log(this.tabRoutes)
      //let func = this.tabRoutes.find(item => {return item.path === key})
      //console.log(func)
      //this.$store.commit('set_funcs', func)
    },
  },
};
</script>
<style>
.leftmenu:not(.el-menu--collapse) {
    width: 150px;
    /* min-height: 400px; */
  }
</style>
